import { takeEvery, takeLatest } from 'redux-saga/effects'

import coreSaga from 'src/core/store/ducks/sagas'

import { MyTeamActionTypes } from './my-team/types'
import * as MyTeamSagas from './my-team/sagas'

import { IntegrationTypes } from './integrations/types'
import * as IntegrationSagas from './integrations/sagas'

import { ReceiptsActionTypes } from './receipts/types'
import * as ReceiptsSagas from './receipts/sagas'

import { ReportsActionTypes } from './reports/types'
import * as ReportsSagas from './reports/sagas'

export default [
  ...coreSaga,
  takeLatest(MyTeamActionTypes.GET_MY_TEAM, MyTeamSagas.getMyTeam),
  takeLatest(
    IntegrationTypes.GET_INTEGRATION_CREDENTIALS,
    IntegrationSagas.getIntegrationCredentials
  ),
  takeLatest(
    IntegrationTypes.SET_INTEGRATION_CREDENTIAL,
    IntegrationSagas.setIntegrationCredential
  ),
  takeLatest(ReceiptsActionTypes.REMOVE_RECEIPT, ReceiptsSagas.removeReceipt),
  takeLatest(ReceiptsActionTypes.SAVE_RECEIPT, ReceiptsSagas.saveReceipt),
  takeEvery(
    ReportsActionTypes.GET_REPORTS_RESOURCE,
    ReportsSagas.getReportsResource
  ),
  takeLatest(ReportsActionTypes.GET_REPORTS, ReportsSagas.getReports)
]
